import { render, staticRenderFns } from "./NotificationSettingModal.vue?vue&type=template&id=f81687e2"
import script from "./NotificationSettingModal.vue?vue&type=script&lang=js"
export * from "./NotificationSettingModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingModal.vue?vue&type=style&index=0&id=f81687e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports